module.exports = __webpack_public_path__ + "img/twitch2.d09aae96.svg";